// packages/shared/utils/fileFormatters.js

// Primary: turn URL- or path-like strings into a nice display name.
// - Decodes %20 and other encodings
// - Converts '+' to spaces
// - Strips query/hash
// - Works for URLs or plain paths
export function formatFileName(raw = '') {
  if (!raw) return '';
  let name = raw;

  // If it's a URL, grab the last path segment
  try {
    const u = new URL(raw);
    name = u.pathname.split('/').pop() || raw;
  } catch {
    // Not a URL: take basename from path (handles / and \)
    name = String(raw).split(/[\\/]/).pop();
  }

  // Drop query/hash
  name = name.replace(/[?#].*$/, '');

  // Decode percent-escapes; tolerate bad encodings
  try {
    name = decodeURIComponent(name);
  } catch {}

  // Some systems use '+' for spaces
  name = name.replace(/\+/g, ' ');

  return name;
}

// OPTIONAL: handy extras you can use elsewhere

export function getFileExtension(name = '') {
  const base = formatFileName(name);
  const i = base.lastIndexOf('.');
  return i > -1 ? base.slice(i + 1).toLowerCase() : '';
}

const MIME_BY_EXT = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  csv: 'text/csv',
  json: 'application/json',
  zip: 'application/zip',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
};

export function guessMimeFromName(name = '') {
  const ext = getFileExtension(name);
  return MIME_BY_EXT[ext] || null;
}

export function formatFileSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = n / 1024,
    i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}

export default formatFileName;
